import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import "core-js/modules/web.dom-collections.iterator.js";
import { useEffect, useState } from "react";
import styled from "styled-components";
import isDefined from "../../Core/isDefined";
import { RawButton } from "../../Styled/Button";
import { StyledIcon } from "../../Styled/Icon";
import Text from "../../Styled/Text";
import { CollapseIcon } from "../Custom/Collapsible/Collapsible";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A generic panel component for left, right, context items etc.
 */
export const Panel = props => {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (isDefined(props.isOpen)) {
      setIsOpen(props.isOpen);
    }
  }, [props.isOpen]);
  const toggleOpen = () => {
    const newIsOpen = !isOpen;
    // Only update isOpen state if onToggle doesn't consume the event
    if (!props.onToggle || !props.onToggle(newIsOpen)) setIsOpen(newIsOpen);
  };
  return props.title && props.collapsible ? /*#__PURE__*/_jsxs(Wrapper, {
    className: props.className,
    children: [/*#__PURE__*/_jsxs(_StyledCollapsibleTitleBar, {
      onClick: toggleOpen,
      fullWidth: true,
      isOpen: isOpen,
      $_css: isOpen ? "15px" : "0px",
      children: [props.icon !== undefined ? /*#__PURE__*/_jsx(Icon, {
        glyph: props.icon,
        styledWidth: "16px",
        styledHeight: "16px"
      }) : null, /*#__PURE__*/_jsx(Title, {
        children: props.title
      }), /*#__PURE__*/_jsx(CollapseIcon, {
        isOpen: isOpen
      })]
    }), isOpen ? /*#__PURE__*/_jsx(Content, {
      children: props.children
    }) : null]
  }) : /*#__PURE__*/_jsxs(Wrapper, {
    className: props.className,
    children: [props.title !== undefined && /*#__PURE__*/_jsxs(TitleBar, {
      children: [props.icon !== undefined ? /*#__PURE__*/_jsx(Icon, {
        glyph: props.icon,
        styledWidth: "16px",
        styledHeight: "16px"
      }) : null, /*#__PURE__*/_jsx(Title, {
        children: props.title
      }), props.menuComponent]
    }), /*#__PURE__*/_jsx(Content, {
      children: props.children
    })]
  });
};

/** Simple PanelButton - this mimics style of CollapsibleTitleBar */
export const PanelButton = _ref => {
  let {
    onClick,
    title
  } = _ref;
  return /*#__PURE__*/_jsx(Wrapper, {
    children: /*#__PURE__*/_jsx(_StyledCollapsibleTitleBar2, {
      onClick: onClick,
      fullWidth: true,
      isOpen: false,
      activeStyles: true,
      children: /*#__PURE__*/_jsx(_StyledTitle, {
        children: title
      })
    })
  });
};
const Wrapper = styled.div.withConfig({
  displayName: "Panel__Wrapper",
  componentId: "sc-lldl1f-0"
})(["background-color:", ";margin:15px 15px 0px 15px;padding:15px;border-radius:5px;"], p => p.theme.darkWithOverlay);
const TitleBar = styled.div.withConfig({
  displayName: "Panel__TitleBar",
  componentId: "sc-lldl1f-1"
})(["box-sizing:border-box;display:flex;flex-direction:row;justify-content:space-between;align-items:center;border-bottom:1px solid ", ";padding-bottom:15px;margin-bottom:5px;"], p => p.theme.darkLighter);
const CollapsibleTitleBar = styled(RawButton).withConfig({
  displayName: "Panel__CollapsibleTitleBar",
  componentId: "sc-lldl1f-2"
})(["text-align:left;box-sizing:border-box;display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding-bottom:15px;margin-bottom:5px;", ";"], p => p.isOpen ? "border-bottom: 1px solid ".concat(p.theme.darkLighter) : "");
var _StyledCollapsibleTitleBar2 = styled(CollapsibleTitleBar).withConfig({
  displayName: "Panel___StyledCollapsibleTitleBar2",
  componentId: "sc-lldl1f-3"
})({
  paddingBottom: "0px"
});
var _StyledCollapsibleTitleBar = styled(CollapsibleTitleBar).withConfig({
  displayName: "Panel___StyledCollapsibleTitleBar",
  componentId: "sc-lldl1f-4"
})(p => ({
  paddingBottom: p.$_css
}));
const Title = styled(Text).attrs({
  textLight: true,
  medium: true
}).withConfig({
  displayName: "Panel__Title",
  componentId: "sc-lldl1f-5"
})(["flex-grow:1;"]);
var _StyledTitle = styled(Title).withConfig({
  displayName: "Panel___StyledTitle",
  componentId: "sc-lldl1f-6"
})({
  textAlign: "center"
});
const Icon = styled(StyledIcon).attrs({
  styledWidth: "18px",
  styledHeight: "18px",
  light: true
}).withConfig({
  displayName: "Panel__Icon",
  componentId: "sc-lldl1f-7"
})([""]);
const Content = styled.div.withConfig({
  displayName: "Panel__Content",
  componentId: "sc-lldl1f-8"
})(["color:", ";"], p => p.theme.textLight);